module.exports = __webpack_public_path__ + "img/rank_2.f1c80d4a.png";